import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-misc-links',
  templateUrl: './misc-links.component.html',
  styleUrls: ['./misc-links.component.css']
})
export class MiscLinksComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
